const stepRegistry = new Map();
/** Register a step class under a stable type key (e.g. 'executeWorkflow'). */
export function registerStep(type, ctor) {
    if (stepRegistry.has(type)) {
        throw new Error(`FAF step type already registered: ${type}`);
    }
    stepRegistry.set(type, ctor);
}
/** @deprecated Alias — prefer registerStep (decorators are not enabled in this project). */
export const RegisterStep = registerStep;
export function getRegisteredStepTypes() {
    return [...stepRegistry.keys()];
}
export function createStepByType(type) {
    const Ctor = stepRegistry.get(type);
    if (!Ctor) {
        throw new Error(`Unknown FAF step type: ${type}`);
    }
    const step = new Ctor();
    step.type = type;
    return step;
}
/** Deserialize a step JSON (including nested then/else on container steps). */
export function createStepFromJson(json) {
    if (!json?.type || typeof json.type !== 'string') {
        throw new Error('FAF step JSON missing type');
    }
    const step = createStepByType(json.type);
    step.fromJSON(json);
    return step;
}
/** Run an ordered list of steps against a shared context (used by engine + IfStep). */
export async function executeSteps(steps, context, options) {
    const stopOnError = options?.stopOnError !== false;
    for (const step of steps) {
        if (context.shouldStop) {
            context.log(`[FAF] stopped before step type=${step.type}`);
            break;
        }
        const label = step.name || step.type;
        context.log(`[FAF] running step: ${label}`);
        try {
            await step.execute(context);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            context.log(`[FAF] step error (${label}): ${message}`);
            if (stopOnError) {
                context.shouldStop = true;
                break;
            }
        }
    }
    return context;
}
/**
 * Abstract action step: execute at a milestone, optionally render admin config UI.
 */
export class FormActionFrameworkStep {
    constructor() {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    toJSON() {
        return {
            type: this.type,
            name: this.name || undefined,
            config: { ...this.config },
        };
    }
    fromJSON(json) {
        const record = json;
        if (typeof record.type === 'string')
            this.type = record.type;
        if (typeof record.name === 'string')
            this.name = record.name;
        if (record.config && typeof record.config === 'object') {
            this.config = { ...record.config };
        }
    }
}
